import ThankYouSidebar from "@/components/templates/Checkout/components/thank-you-sidebar";
import { getOrder } from "@/lib/medusa/data/products";
import { notFound } from "next/navigation";
import ThankYouSummary from "@/components/templates/Checkout/components/thank-you-summary";
import ThankYouHeader from "@/components/templates/Checkout/components/thank-you-header";

type ThankYouProps = {
  resolution: Resolution;
};

const ThankYou = async ({ resolution }: ThankYouProps) => {
  const [, orderId] = resolution.slugs;
  const order = await getOrder(orderId);

  if (!order) return notFound();

  return (
    <>
      <section className="text-dark-primary bg-[#FBF9F899] pt-8 md:py-8">
        <div className="mx-auto max-w-[884px] space-y-10 px-3.5 md:py-[70px]">
          <ThankYouHeader locale={resolution.locale} />
          <div className="flex flex-col-reverse items-start md:flex-row md:gap-2.5">
            <ThankYouSummary order={order} locale={resolution.locale} />
            <ThankYouSidebar locale={resolution.locale} />
          </div>
        </div>
      </section>
      <hr className="border-primary-light/50 md:hidden" />
    </>
  );
};

export default ThankYou;
